import Typography from "@mui/material/Typography";
import { z } from "zod";

import FormEngine, { FormEngineProps } from "@components/FormEngine/FormEngine";

import { regex } from "@utils/zod";

export const PATIENT_DETAILS_FORM_ID = "email-verification-form";

const PatientDetailsForm = ({
  onSubmit,
  ...rest
}: Partial<FormEngineProps>) => {
  return (
    <>
      <Typography variant="body1">
        We're almost there. Just a few more details are needed to finalize your
        account and confirm your appointment.
      </Typography>
      <FormEngine
        formId={PATIENT_DETAILS_FORM_ID}
        onSubmit={onSubmit}
        data={{
          dateOfBirth: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          zipcode: "",
          gender: "Male",
        }}
        schema={[
          {
            name: "dateOfBirth",
            label: "Date of Birth",
            type: "date",
            rule: z.string().min(1),
            fieldProps: {
              formatValue: "MM/DD/YYYY",
              disableFuture: true,
            },
          },
          {
            name: "phone",
            label: "Phone Number",
            type: "pattern",
            rule: z.string().min(10),
            fieldProps: {
              format: "(###) ###-####",
            },
          },
          {
            name: "address",
            label: "Street Address",
            type: "input",
            rule: z.string().min(1),
            fieldProps: {
              formatterRules: ["letters", "numbers", "spaces"],
            },
          },
          {
            name: "city",
            label: "City",
            type: "input",
            rule: z.string().min(1),
            fieldProps: {
              formatterRules: ["letters", "spaces"],
            },
          },
          {
            name: "zipcode",
            label: "Zipcode",
            type: "input",
            rule: regex.zipcode,
            fieldProps: {
              formatterRules: ["numbers", "-"],
              formatOnChange: (value) => {
                if (value.length > 10) return value.substring(0, 10);
                if (value.length === 6 && !value.includes("-")) {
                  return `${value.substring(0, 5)}-${value.substring(5, value.length)}`;
                }

                return value;
              },
            },
          },
          {
            name: "gender",
            label: "Biological Sex",
            type: "radio",
            rule: z.string().min(1),
            fieldProps: {
              row: true,
              sx: { backgroundColor: "transparent" },
              options: [
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
              ],
            },
          },
        ]}
        {...rest}
      />
    </>
  );
};

export default PatientDetailsForm;
